import { FC, ReactNode } from 'react';
import { Box, SxProps, Tooltip } from '@mui/material';
import { IconButton } from 'shared/ui/IconButton';

type ClipboardPropsType = {
	text: string;
	content?: ReactNode;
	sx?: SxProps;
};

const Clipboard: FC<ClipboardPropsType> = ({ text, content, sx }) => {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
			{content || text}
			<Tooltip title={'copy'} arrow>
				<IconButton
					iconId={'copy'}
					onClick={() => {
						navigator.clipboard.writeText(text);
					}}
				/>
			</Tooltip>
		</Box>
	);
};

export default Clipboard;
